import { render, staticRenderFns } from "./FloatingLiveChat.vue?vue&type=template&id=4a4a79ef&"
import script from "./FloatingLiveChat.vue?vue&type=script&lang=js&"
export * from "./FloatingLiveChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingLiveChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports